import { render, staticRenderFns } from "./ExtentControl.vue?vue&type=template&id=9304b642"
import script from "./ExtentControl.vue?vue&type=script&lang=js"
export * from "./ExtentControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports